class determineHost {

host = window.location.host;

 determineTitle (){
    if(this.host === process.env.REACT_APP_BSBS_BASE){
      return "Blue Skies, Black Smoke";
    } else if (this.host === process.env.REACT_APP_SNAPLANDS_BASE){
        return "South of Snaplands";
    } else if (this.host === process.env.REACT_APP_GRADIA_BASE){
        return "Tails of Gradia";
    } else if (this.host === process.env.REACT_APP_SCALESAGAS_BASE){
      return "Scalesagas";
    }
    return "Tails of Gradia";
  }

   determineFetch (){
    if(this.host === process.env.REACT_APP_BSBS_BASE){
      return "bsbs";
    } else if (this.host === process.env.REACT_APP_SNAPLANDS_BASE){
        return "snaplands";
    } else if (this.host === process.env.REACT_APP_GRADIA_BASE){
        return "gradia";
    } else if (this.host === process.env.REACT_APP_SCALESAGAS_BASE){
      return "scalesagas";
    }
    return "gradia";
  }

}

  export default determineHost;